import { ProgramDocumentDetailsResponse } from "../../../../../../../api/services/program/models";

export const DocumentsTabFormKeys = {
  fileName: "fileName",
  type: "type",
  description: "description",
  uploadedDate: "uploadedDate",
  uploadedBy: "uploadedBy",
};

export const UploadNewDocumentFormKey = {
  documentType: "documentType",
  uploadedDate: "uploadedDate",
  description: "description",
  file: "file",
} as const;

export interface ProgramDocumentDetailsRowValue
  extends ProgramDocumentDetailsResponse {
  uploadedBy?: string;
  [key: string]: any;
}
